/*
 * @Author: ghy
 * @Date: 2023-07-17 13:30:44
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-09 11:18:01
 * @Description: 
 */
import axios from "axios";
import { Message } from "element-ui";
// create an axios instance
const service = axios.create({
  withCredentials: false // send cookies when cross-domain requests
});

service.interceptors.request.use(
  function(config) {
    //配置发送请求的信息
    config.headers["authType"] = "adminAuth";
    config.headers["Content-Type"] = "application/json";
    config.headers["token"] = localStorage.getItem("user_token") || "1111";
    //为get请求增加时间戳，消除缓存的影响
    if (config.method == "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
     // console.log(config.params)
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  function(response) {
    //配置请求回来的信息
    const res = response.data;
   // console.log(response)
    if(response.config.params && response.config.params.fileId || response.config.params && response.config.params.fileGuid){ //文件下载，直接返回response
      return response  
    }
   // console.log(response)
    if (response.status !== 200) {
      Message({
        message: response.data.message,
        type: "error"
      });
    } else {
      if (res.code !== '0') {
        if(res.code == '401'){
          localStorage.removeItem("access_token") 
          localStorage.removeItem("modulesIdArr")
          localStorage.removeItem("roleId")
        }
        Message({
          // 状态码除了200外还有特殊状态码需要判断，自己页面单独判断就行
          message: res.message || res.msg || "Error",
          type: "error",
          duration: 5 * 1000
        });
        return Promise.reject(new Error(res.message || "Error"));
      } else {
        return res;
      }
    }
  },
  function(error) {
    if (error.response.status == 403) {
      Message({
        message: "您暂无此操作权限，请联系管理员",
        type: "error"
      });
    }
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/api/index.js